const RESET_QUANTITY = "RESET_QUANTITY";
const RESET_QUANTITY_SUCCESS = "RESET_QUANTITY_SUCCESS";
const RESET_QUANTITY_FAILURE = "RESET_QUANTITY_FAILURE";
const CLEAR_RESET_QUANTITY = "CLEAR_RESET_QUANTITY";

const ResetQuantitySymbols = {
  RESET_QUANTITY_SUCCESS,
  RESET_QUANTITY_FAILURE,
  RESET_QUANTITY,
  CLEAR_RESET_QUANTITY,
};
export default ResetQuantitySymbols;
